export type Step = {
	id: StepTypes;
	title: string;
	shortTitle: string;
	text: string,
	status: '' | 'completed' | 'invalid',
	information: string,
};

export enum StepTypes {
	shapeSize = 'shape-and-size',
	cutouts = 'cutouts',
	drillholes = 'drillholes',
	thickness = 'thickness',
	edgeFinish = 'edge-finish',
	material = 'material',
	sideSelection = 'side-selection',
}
